var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-block__footer"},[_c('img',{attrs:{"src":require('~/assets/images/logolabeyriev2.png'),"height":"60","alt":"logo-labeyrie"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }